module.exports = __webpack_public_path__ + "static/media/add_slack_notification_ja.0d07a248.gif";